import React from 'react';
import { DefaultOverride } from '../override';
import { ColumnItem } from '../column-item';
import { useConfig } from '../config-context';
import { ButtonMaxWidthElement } from './button-max-width-element';
import { ButtonMinWidthElement } from './button-min-width-element';
export function Button(props) {
    const { align = 'center', backgroundColor = '#414141', border = 'none', borderRadius = '3px', children, color = '#ffffff', cssClass, fontFamily = 'Ubuntu, Helvetica, Arial, sans-serif', fontSize = '13px', fontStyle, fontWeight = 'normal', height, href, innerPadding = '10px 25px', maxWidth, minWidth, padding = '10px 25px', rel, textDecoration = 'none', width, override, overrideProps, onClick, experiments = {}, } = props;
    const OverrideWith = override || DefaultOverride;
    const isSelectionFixEnabled = experiments['specs.so.public.FixButtonTabSelection'] === 'true';
    const style = {
        display: isSelectionFixEnabled ? 'block' : 'inline-block',
        background: backgroundColor,
        color,
        fontFamily,
        fontSize,
        fontStyle,
        fontWeight,
        lineHeight: '120%',
        margin: '0',
        textDecoration,
        textTransform: 'none',
        padding: innerPadding,
        msoPaddingAlt: '0px',
        borderRadius,
    };
    const config = useConfig();
    const ButtonMinWidth = config.implementations.ButtonMinWidth || ButtonMinWidthElement;
    return (React.createElement(ColumnItem, { align: align, padding: padding, cssClass: cssClass, verticalAlign: "middle" },
        React.createElement(OverrideWith, { ...overrideProps },
            React.createElement(ButtonMaxWidthElement, { maxWidth: maxWidth },
                React.createElement("table", { border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: {
                        width,
                        borderCollapse: 'separate',
                        lineHeight: '100%',
                    }, width: width },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { align: "center", bgcolor: backgroundColor === 'none' ? undefined : backgroundColor, role: "presentation", style: {
                                    border,
                                    borderRadius,
                                    cursor: 'auto',
                                    fontStyle,
                                    height,
                                    msoPaddingAlt: innerPadding,
                                    background: backgroundColor,
                                    ...(isSelectionFixEnabled ? { overflow: 'visible' } : {}),
                                }, valign: "middle", onClick: onClick },
                                href ? (React.createElement("a", { href: href, rel: rel, style: style, target: "_blank" }, children)) : (React.createElement("p", { style: style }, children)),
                                React.createElement(ButtonMinWidth, { minWidth: minWidth })))))))));
}
//# sourceMappingURL=button.js.map